import { initialAccountManagementState } from 'redux/initialState';
import { status } from 'constants/general';

import accountManagementActionTypes from './action-types';

const accountManagementReducer = (state = initialAccountManagementState, { type, payload }) => {
  switch (type) {
    case accountManagementActionTypes.FETCH_REQUEST_OTP_INFO:
      return {
        ...state,
        requestOtpInfo: {
          status: status.FETCHING,
        },
      };

    case accountManagementActionTypes.FETCH_REQUEST_OTP_INFO_SUCCESS:
      return {
        ...state,
        requestOtpInfo: {
          status: status.SUCCESS,
        },
      };

    case accountManagementActionTypes.FETCH_REQUEST_OTP_INFO_FAIL:
      return {
        ...state,
        requestOtpInfo: {
          status: status.FAIL,
        },
      };

    case accountManagementActionTypes.FETCH_SIGN_WITH_OTP_INFO:
      return {
        ...state,
        signWithOtpInfo: {
          status: status.FETCHING,
        },
      };

    case accountManagementActionTypes.FETCH_SIGN_WITH_OTP_INFO_SUCCESS:
      return {
        ...state,
        signWithOtpInfo: {
          status: status.SUCCESS,
        },
      };

    case accountManagementActionTypes.FETCH_SIGN_WITH_OTP_INFO_FAIL:
      return {
        ...state,
        signWithOtpInfo: {
          status: status.FAIL,
        },
      };

    case accountManagementActionTypes.FETCH_LOGIN_INFO:
      return {
        ...state,
        loginInfo: {
          status: status.FETCHING,
        },
      };

    case accountManagementActionTypes.FETCH_LOGIN_INFO_SUCCESS:
      return {
        ...state,
        loginInfo: {
          status: status.SUCCESS,
          details: payload,
        },
      };

    case accountManagementActionTypes.FETCH_LOGIN_INFO_FAIL:
      return {
        ...state,
        loginInfo: {
          status: status.FAIL,
        },
      };

    default:
      return state;
  }
};

export default accountManagementReducer;
